import {CreateReducer} from '../utils/create_reducer';
import {GET_TEMPLATE_LIST} from "../actions/report_template_action";

const initState = {
    isFetching:true
};

const reportTemplateReducer = CreateReducer(initState, {
    [GET_TEMPLATE_LIST](state, action) {
        return {...state,templates:action.payload}
    }
});

export default reportTemplateReducer;


// WEBPACK FOOTER //
// ./src/reducers/report_template_reducer.js